/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {DialogExampleDefault, DialogExampleHelpButton, DialogExampleFullscreen, DialogExampleVerticalAlignment, DialogExampleDelayClose, DialogExampleCustomTrigger, DialogExampleProgressIndicator, FullDialogExample, DialogConfirmDefault, DialogConfirmDelete, DialogConfirmLoggedOut, DialogConfirmCookies, DialogConfirmScrollableContent} from 'Docs/uilib/components/dialog/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    ol: "ol",
    li: "li",
    a: "a",
    code: "code",
    h3: "h3",
    p: "p"
  }, _provideComponents(), props.components), {VisibleWhenVisualTest} = _components;
  if (!VisibleWhenVisualTest) _missingMdxReference("VisibleWhenVisualTest", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Table of contents"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/uilib/components/dialog/demos#demos-for-variant-information",
          children: "Inform demos"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/uilib/components/dialog/demos#demos-for-variant-confirmation",
          children: "Confirm demos"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.h2, {
      children: ["Demos for variant ", _jsx(_components.code, {
        children: "information"
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Basic Dialog"
    }), "\n", _jsx(DialogExampleDefault, {}), "\n", _jsx(_components.h3, {
      children: "Dialog as help button"
    }), "\n", _jsx(DialogExampleHelpButton, {}), "\n", _jsx(_components.h3, {
      children: "Top aligned Dialog"
    }), "\n", _jsx(DialogExampleVerticalAlignment, {}), "\n", _jsx(_components.h3, {
      children: "Dialog with custom trigger"
    }), "\n", _jsx(DialogExampleCustomTrigger, {}), "\n", _jsx(_components.h3, {
      children: "Dialog with custom content"
    }), "\n", _jsx(FullDialogExample, {}), "\n", _jsx(_components.h3, {
      children: "Fullscreen Dialog"
    }), "\n", _jsx(DialogExampleFullscreen, {}), "\n", _jsx(_components.h3, {
      children: "Dialog as progress indicator"
    }), "\n", _jsx(DialogExampleProgressIndicator, {}), "\n", _jsx(_components.h3, {
      children: "Dialog with close delay"
    }), "\n", _jsx(DialogExampleDelayClose, {}), "\n", _jsxs(_components.h2, {
      children: ["Demos for variant ", _jsx(_components.code, {
        children: "confirmation"
      })]
    }), "\n", _jsx(_components.h3, {
      children: "Confirm dialog"
    }), "\n", _jsx(DialogConfirmDefault, {}), "\n", _jsx(_components.h3, {
      children: "Deletion Dialog"
    }), "\n", _jsxs(_components.p, {
      children: ["A ", _jsx(_components.code, {
        children: "confirmType=\"warning\""
      }), " will enhance the context by applying a red color to the icon, as in the deletion scenario."]
    }), "\n", _jsx(DialogConfirmDelete, {}), "\n", _jsx(_components.h3, {
      children: "Logged out Dialog"
    }), "\n", _jsxs(_components.p, {
      children: ["Use the ", _jsx(_components.code, {
        children: "openState"
      }), " property to automatically trigger the Dialog, here demonstrated with a button for simplicity. You can also change the default confirm text and hide the decline button when suited."]
    }), "\n", _jsx(DialogConfirmLoggedOut, {}), "\n", _jsx(_components.h3, {
      children: "Cookie concent Dialog"
    }), "\n", _jsxs(_components.p, {
      children: ["Provide a custom set of buttons, like this cookie concent Dialog that has a ", _jsx(_components.code, {
        children: "tertiary"
      }), " \"Administrate\" button. Notice that the ", _jsx(_components.code, {
        children: "close"
      }), " function will be provided for every child of type ", _jsx(_components.a, {
        href: "/uilib/components/button",
        children: "Button"
      }), " given to ", _jsx(_components.code, {
        children: "Dialog.Action"
      }), "."]
    }), "\n", _jsx(DialogConfirmCookies, {}), "\n", _jsx(VisibleWhenVisualTest, {
      children: _jsx(DialogConfirmScrollableContent, {})
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
